// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3QOOy","tab":"ProcedureTabs_tab__2ydFh"};